import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import { PurchasePlusBaseErrorFragmentDoc } from './BaseError.generated'
import * as Types from './purchasePlus_graphql'

export const CreateInvoiceLineItemDocument = gql`
  mutation CreateInvoiceLineItem($input: CreateInvoiceLineItemInput!) {
    createInvoiceLineItem(input: $input) {
      invoiceLineItem {
        id
      }
      errors {
        ...PurchasePlusBaseError
      }
    }
  }
  ${PurchasePlusBaseErrorFragmentDoc}
` as unknown as DocumentNode<Types.CreateInvoiceLineItemMutation, Types.CreateInvoiceLineItemMutationVariables>
